<ng-container>
  <img
    class="post-card-image"
    [src]="post().picture?.defaultUrl"
    [alt]="post().title | trans"
  />

  <div class="post-card-infos">
    <h5 [title]="post().title | trans" class="post-card-title">
      {{ post().title | trans }}
    </h5>

    <p [title]="post().category?.title | trans" class="post-card-category">
      {{ post().category?.title | trans }}
    </p>

    <div [renderHtml]="post().shortDescription" class="post-card-desc"></div>

    <div class="post-card-ts">
      <span class="post-card-ts-item">
        <fa-icon [icon]="icons['clock']" />

        <span> {{ updatedAt() }} </span>
      </span>

      <span class="post-card-ts-item">
        <fa-icon [icon]="icons['userCircle']" />

        <span> {{ post().updatedBy }} </span>
      </span>
    </div>
  </div>
</ng-container>
